import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";

export const setUploadedVideoList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_UPLOADED_VIDEO_LIST,
    payload: payload,
  });
};

export const removeUploadedVideo = (dispatch, payload) => {
  let keys = [];
  keys.push(payload.selectedFileKey);
  userService
    .deleteUploadedFile(keys, payload.currentUserId, payload.authorization)
    .then((res) => {
      dispatch({
        type: ActionTypes.REMOVE_UPLOADED_VIDEO,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const renameUploadedVideo = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RENAME_VIDEO_LOADING,
    payload: true,
  });
  userService
    .renameVideo(payload.id, payload.videoName + ".mp4", payload.schoolId)
    .then(() => {
      dispatch({
        type: ActionTypes.RENAME_VIDEO_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_RENAME_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.RENAME_UPLOADED_VIDEO,
        payload: payload,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.RENAME_VIDEO_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_RENAME_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const resetUploadVideoInitialState = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RESET_UPLOAD_VIDEO_INITIAL_STATE,
    payload: null,
  });
};
